import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
var _excluded = ["children", "className", "top"];

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import ConfigProvider from '@jd/jmtd/es/ConfigProvider';
import { createContext } from '@jd/jmtd/es/tools/context';
import Card from '@jd/jmtd/es/Card';
import classNames from '@jd/jmtd-tools/es/classnames';
import { closeOtherPopover } from '@jd/jmtd/es/Popover';
import refresh from '@jd/jmtd-tools/es/refresh';
import ResizeObserver from 'resize-observer-polyfill';
import { css, px } from '@jd/jmtd-tools/es/css';
import { setClass } from '@jd/jmtd-tools/es/element';
import ConfigConsumer from '@jd/jmtd/es/ConfigConsumer';
export var affixCardContext = createContext({});

var AffixCard = /*#__PURE__*/function (_PureComponent) {
  _inherits(AffixCard, _PureComponent);

  var _super = _createSuper(AffixCard);

  function AffixCard(props) {
    var _this;

    _classCallCheck(this, AffixCard);

    _this = _super.call(this, props);
    _this.state = {
      affixed: false,
      affixExpanded: false
    };
    return _this;
  }

  _createClass(AffixCard, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      var main = this.main,
          affixTop = this.props.top;
      var cardRef = main.parentElement;
      this.affixRefresh = refresh(function () {
        var affixed = _this2.state.affixed;

        var _cardRef$getBoundingC = cardRef.getBoundingClientRect(),
            top = _cardRef$getBoundingC.top;

        var curAffixed = top < affixTop;

        if (curAffixed !== affixed && !_this2.collapsing) {
          _this2.collapsing = setTimeout(function () {
            _this2.collapsing = null;
          }, 500);
          closeOtherPopover(null, function (node) {
            var _node$trigger, _node$trigger$classLi;

            if (node !== null && node !== void 0 && (_node$trigger = node.trigger) !== null && _node$trigger !== void 0 && (_node$trigger$classLi = _node$trigger.classList) !== null && _node$trigger$classLi !== void 0 && _node$trigger$classLi.contains('jmtp-dropdown-checkbox-group')) {
              return false;
            }

            return true;
          });

          _this2.setState({
            affixed: curAffixed,
            affixExpanded: false
          });
        }
      });
      this.ro = new ResizeObserver(function () {
        _this2.resize();
      });
      this.ro.observe(cardRef);
      this.ro.observe(main);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      var _this$formGroup;

      this.resize(); // eslint-disable-next-line no-unused-expressions

      (_this$formGroup = this.formGroup) === null || _this$formGroup === void 0 ? void 0 : _this$formGroup.componentDidUpdate();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.affixRefresh && this.affixRefresh.remove();
      this.ro && this.ro.disconnect();
    }
  }, {
    key: "resize",
    value: function resize() {
      var main = this.main,
          placeholder = this.placeholder;
      var cardRef = main.parentElement;

      if (this.lastWidth !== cardRef.offsetWidth) {
        css(main, 'width', px(cardRef.offsetWidth));
      }

      if (this.lastHeight !== main.offsetHeight) {
        css(placeholder, 'height', px(main.offsetHeight));
      }

      this.lastHeight = main.offsetHeight;
      this.lastWidth = cardRef.offsetWidth;
      main.querySelectorAll('.jmtd-card-section').forEach(function (section) {
        setClass(section, 'jmtp-card-section-with-form-group', section.querySelector('.jmtp-form-group:not(.jmtp-form-group-hidden-when-affixed)'));
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var _this$props = this.props,
          children = _this$props.children,
          className = _this$props.className,
          top = _this$props.top,
          other = _objectWithoutProperties(_this$props, _excluded),
          _this$state = this.state,
          affixed = _this$state.affixed,
          affixExpanded = _this$state.affixExpanded;

      return /*#__PURE__*/React.createElement(ConfigProvider // 私有content
      , {
        context: affixCardContext,
        affix: true,
        affixed: affixed,
        affixExpanded: affixExpanded,
        setExpanded: function setExpanded(value) {
          _this3.setState({
            affixExpanded: value
          });
        } // 设置formGroup
        ,
        setFormGroup: function setFormGroup(formGroup) {
          _this3.formGroup = formGroup;
        }
      }, /*#__PURE__*/React.createElement(ConfigConsumer, null, function (_ref) {
        var jmtpAffixCardZIndex = _ref.jmtpAffixCardZIndex;
        return /*#__PURE__*/React.createElement(Card, _extends({
          className: classNames('jmtp-affix-card', className, {
            'jmtp-affix-card-affixed': affixed,
            'jmtp-affix-card-affixed-expand': affixExpanded
          })
        }, other), /*#__PURE__*/React.createElement("div", {
          className: "jmtp-affix-card-placeholder",
          ref: function ref(el) {
            _this3.placeholder = el;
          }
        }), /*#__PURE__*/React.createElement("div", {
          style: {
            top: top,
            zIndex: jmtpAffixCardZIndex
          },
          className: "jmtp-affix-card-main",
          ref: function ref(el) {
            _this3.main = el;
          },
          onTransitionEnd: function onTransitionEnd(e) {
            if (e.target.classList.contains('bd-collapse')) {
              clearTimeout(_this3.collapsing);
              _this3.collapsing = null;
            }
          }
        }, children));
      }));
    }
  }]);

  return AffixCard;
}(PureComponent);

export { AffixCard as default };
AffixCard.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
  top: PropTypes.number
};
AffixCard.defaultProps = {
  className: null,
  children: null,
  top: 0
};